export const conn = "https://zikora-node.herokuapp.com/zikora-api/v1";
// export const conn = "https://api.zikorabank.com/zikora-api/v1";

export const uploadimg =
  "https://zikora-file-upload-356002.ue.r.appspot.com/upload_base64";

export const uploadimg2 =
  "https://zikora-file-upload-356002.ue.r.appspot.com/upload";
